var $51d8721afda4d678$exports = {};
$51d8721afda4d678$exports = {
  "removeButtonLabel": "Odstr\xE1ni\u0165",
  "removeDescription": "Ak chcete odstr\xE1ni\u0165 zna\u010Dku, stla\u010Dte kl\xE1ves Delete."
};
export { $51d8721afda4d678$exports as default };